import { useRef } from "react";
import { Upload, Wand2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

export default function SourcePanel({
  mode, setMode,
  preview, onPickFile,
  docTitle, setDocTitle,
  topic, setTopic,
}) {
  const fileRef = useRef(null);
  return (
    <div className="tb-card p-5" data-testid="tfa-source-panel">
      <Label>Source</Label>
      <div className="mt-2 flex gap-2 p-1 bg-muted rounded-full" role="tablist">
        <button
          onClick={() => setMode("upload")}
          className={`flex-1 py-2 text-sm rounded-full transition ${mode === "upload" ? "bg-card shadow-sm font-medium" : "text-muted-foreground"}`}
          data-testid="tfa-mode-upload"
        >
          <Upload className="h-3.5 w-3.5 inline mr-1.5" /> Document
        </button>
        <button
          onClick={() => setMode("topic")}
          className={`flex-1 py-2 text-sm rounded-full transition ${mode === "topic" ? "bg-card shadow-sm font-medium" : "text-muted-foreground"}`}
          data-testid="tfa-mode-topic"
        >
          <Wand2 className="h-3.5 w-3.5 inline mr-1.5" /> Topic
        </button>
      </div>

      {mode === "upload" ? (
        <>
          <div
            onClick={() => fileRef.current?.click()}
            onDragOver={(e) => e.preventDefault()}
            onDrop={(e) => { e.preventDefault(); const f = e.dataTransfer.files?.[0]; if (f) onPickFile(f); }}
            className="mt-3 cursor-pointer rounded-2xl border-2 border-dashed border-border hover:border-primary/60 transition p-5 text-center bg-muted/20"
            data-testid="tfa-dropzone"
          >
            {preview ? (
              <img src={preview} alt="" className="max-h-48 mx-auto rounded-xl object-contain" />
            ) : (
              <>
                <span className="mx-auto h-11 w-11 grid place-items-center rounded-2xl bg-primary/10 text-primary mb-2">
                  <Upload className="h-5 w-5" />
                </span>
                <p className="text-sm font-medium">Click or drop to upload</p>
                <p className="text-[11px] text-muted-foreground mt-1">JPG, PNG, WEBP · auto-compressed</p>
              </>
            )}
            <input ref={fileRef} type="file" accept="image/*" hidden onChange={(e) => onPickFile(e.target.files?.[0])} data-testid="tfa-file-input" />
          </div>
          <div className="mt-3">
            <Label>Title</Label>
            <Input value={docTitle} onChange={(e) => setDocTitle(e.target.value)} placeholder="e.g. Photosynthesis textbook page" className="mt-1.5 h-11 rounded-xl" data-testid="tfa-doc-title" />
          </div>
        </>
      ) : (
        <div className="mt-3">
          <Label>Topic to teach</Label>
          <Textarea
            rows={4}
            value={topic}
            onChange={(e) => setTopic(e.target.value)}
            placeholder="e.g. Newton's laws of motion · Photosynthesis · Subject-verb agreement"
            className="mt-1.5 rounded-xl"
            data-testid="tfa-topic-input"
          />
        </div>
      )}
    </div>
  );
}
